import './history-popin.component.ajscss';

import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './history-popin.component.html';

class HystoryPopinCtrl implements IComponentController {
  $onInit() {}
}

export class HistoryPopin implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    epticaEvents: '<',
    memo: '<',
  };
  controller = [HystoryPopinCtrl];
}

export default 'historyPopin';
